var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4454",
    "data-name": "Group 4454",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.426,
    height: 28.426,
    viewBox: "0 0 28.426 28.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M0,0H28.426V28.426H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M2,10.107H24.5a1.184,1.184,0,0,1,1.184,1.184V23.135A1.184,1.184,0,0,1,24.5,24.32H3.184A1.184,1.184,0,0,1,2,23.135ZM3.184,3H20.951V7.738H2V4.184A1.184,1.184,0,0,1,3.184,3ZM17.4,16.029V18.4h3.553V16.029Z",
    transform: "translate(0.369 0.553)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIcon);
export default __webpack_public_path__ + "static/media/depositIcon.1e2aaa95e49098dd711027ca695b8d83.svg";
export { ForwardRef as ReactComponent };